<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Prep Task Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${prep_process.name} ${prep_task.name}`">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit prep task'">
      <template #gated-content>
        <prep-task-form
          :prep_process="prep_process"
          :prep_task="prep_task"
          @submit="submit"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import PrepTaskForm from "@/components/lab/preptask/PrepTaskForm";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { prepTaskNotifications } from "@/shared/notifications";

const PrepTaskRepository = LabRepositoryFactory.get("prepTask");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "PrepTaskEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    PrepTaskForm,
  },
  data() {
    return {
      loading: true,
      prep_task_id: this.$route.params.prep_task_id || null,
      prep_task: null,
      prep_process: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: `/prep-processes/${this.prep_process.id}`,
            title: "Prep task list",
          },
          {
            icon: "fa-eye",
            linkto: `/prep-tasks/${this.prep_task_id}`,
            title: "View prep tasks",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async init() {
      this.prep_task = await getModel({
        model_type: "prep_task",
        id: this.prep_task_id,
        message: this.$bvToast,
      });
      this.prep_process = await getModel({
        model_type: "prep_process",
        id: this.prep_task.prep_process_id,
        message: this.$bvToast,
      });

      this.loading = false;
    },
    async submit(form_data) {
      const { name, description, relations } = form_data;
      const payload = {
        name,
        description,
        relations,
        prep_process_id: this.prep_process.id,
      };

      try {
        const { data } = await PrepTaskRepository.update(
          this.prep_task_id,
          payload
        );

        this.editSuccess();

        this.$router.push(`/prep-tasks/${data.id}`);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Task update Failed.",
          variant: "danger",
        });
      }
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
  notifications: prepTaskNotifications,
};
</script>
